import { render, staticRenderFns } from "./LimpezaEstoque.vue?vue&type=template&id=7dceb8cc"
import script from "./LimpezaEstoque.vue?vue&type=script&lang=ts"
export * from "./LimpezaEstoque.vue?vue&type=script&lang=ts"
import style0 from "./LimpezaEstoque.vue?vue&type=style&index=0&id=7dceb8cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports